import { TransactionSource, SourceComponent } from './payment.model';

export class Invoice {
  public InvoiceNumber: string;
  public Customer: string;
  public PaymentTerm: string;
  public DueDate: string;
  public BalanceDue: number;
  public Status: string;
}

export class InvoiceModel {}

export class InvoiceItems {
  constructor(
    public IsFreetext?: boolean,
    public Id?: number,
    public ItemId?: number,
    public ItemType?: string,
    public ManualInvoiceNumber?: string,
    public ItemName?: string,
    public Quantity?: number,
    public Rate?: number,
    public IsTaxExempt?: boolean,
    public ServiceDescription?: string,
    public ProductTaxCode?: string,
    public Amount?: number
  ) {}
}

export class ManualInvoice {
  constructor(
    public Id?: number,
    public InvoiceId?: number,
    public InvoiceNumber?: string,
    public CustomerId?: number,
    public DueDate?: string,
    public PartialDue?: number,
    public Balance?: number,
    public TotalAmount?: number,
    public PaymentTermId?: string,
    public Status?: string,
    public PaidToDate?: number,
    public InvoiceDate?: any,
    public Discount?: number,
    public DiscountType?: string,
    public Tax?: number,
    public TaxableTotal?: number,
    public NonTaxableTotal?: number,
    public TaxType?: string,
    public Tip?: number,
    public TipType?: string,
    public PaymentTerm?: string,
    public PaymentTermValue?: number,
    public ReferenceInvoiceNumber?: string,
    public IsDraft?: boolean,
    public Notes?: string,
    public TCPId?: number,
    public TCPIds?: any,
    public InvoiceItems?: InvoiceItems[],
    public PartialDueType?: string,
    public ShowTCP?: boolean,
    public LocationId?: number,
    public CreatedBy?: number,
    public CreatedDate?: Date,
    public UpdatedBy?: number,
    public UpdatedDate?: Date,
    public LocationName?: string,
    public IsRecurringPayment?: boolean,
    public IsRecurringInvoice?: boolean,
    public UpdatedByUserName?: string,
    public CreatedByUserName?: string,
    public CreatedDateTZBased?: Date,
    public UpdatedDateTZBased?: Date,
    public IsManuallyEnteredInvoiceNo?: boolean,
    public PurchaseOrderNumber?: string,
    public BusinessCustomerContactPersonId?: number,
    public TaxExemptionType?: string
  ) {}
}

export class AutomaticInvoice {
  comments: string;
  createdBy: number;
  createdDate: Date;
  id: number;
  invoiceDate: Date;
  invoiceNumber: string;
  orderAdjustments: any[];
  orderId: string;
  orderItems: any[];
  orderSubTotal: number;
  orderTotal: number;
  source: string;
  statusId: number;
  terminalId: string;
  terms: any;
  updatedBy: number;
  updatedDate: Date;
  voidId: any;
}

export class UpdateManualInvoiceDetail {
  public ManualInvoiceDetail: InvoiceItems;
  public Balance: number;
  public TotalAmount: number;
  public UpdatedBy: number;
}

export class SendDownloadInvoice {
  public InvoiceNumber: string;
  public CustomerName: string;
  public CustomerAddress: string;
  public CustomerEmail: string;
  public BusinessLogo: string;
  public BusinessName: string;
  public BusinessAddress: string;
  public OtherEmailRecipients: string;
}

export class TransactionLogs {
  public Label: string;
  public SurchargeAmount: number = 0;
  public SurchargePercentage: number = 0;
}

export class CreditPayment {
  public cardInfo: CardInfo;

  public orderId: string;
  public invoiceNumber: string;
  public terminalId: string;
  public transactionId: string;
  public amount: number = 0;
  public authAmount: number = 0;
  public currency: string = 'USD';

  public gratuity: number = 0;
  public timestamp: string;

  public requestMultiUseToken: boolean = false;

  public SecretApiKey: string;
  public MID: string;
  public customerId: number;

  public billingAddress: CustomerAddress;
  public shippingAddress: CustomerAddress;
  public Notes: string;

  public TransactionSource: TransactionSource | string;
  public SourceComponent: SourceComponent;
  public isPartialPayment: boolean;

  public cardDataSource: string;
  public Level: string;

  public LocationId: number = 1;
  public Email: string;
  public locationId?: number;
  public htoken?: string;
  public hApiKeyId?: number;
  public sourceComponent?: number;
  public TransactionLogs?: TransactionLogs[];
}
//
// export class CreditPaymentOnline {
//   public cardInfo: CardInfo;
//   public orderId: string;
//   public invoiceNumber: string;
//   public terminalId: string = "ONLINE";
//   public transactionId: string = "0";
//   public amount: number = 0;
//   public currency: string = 'USD';
//   public gratuity: number = 0;
//   public timestamp: string;
//   public requestMultiUseToken: boolean = false;
//   public SecretApiKey: string;
//   public MID: string;
//   public customerId: number;
//   public billingAddress: CustomerAddress;
//   public shippingAddress: [];
//   public TransactionSource: TransactionSource;
//   public SourceComponent: SourceComponent;
//   public orderItems: [];
//   public alias: string;
//   public productId: number;
//   public balanceInquiryType: string = "FOODSTAMP";
//   public recurringSequence: string = "First";
//   public serviceUrl: any;
//   public mid: any;
// }

export class CustomerAddress {
  public Id: number;
  public City: string;
  public Country: string;
  public CountryCode: string;
  public PostalCode: string;
  public Province: string;
  public State: string;
  public StreetAddress1: string;
  public StreetAddress2: string;
  public StreetAddress3: string;
}

export class PaymentPreview {
  public invoiceNumber: string;
  public transactionId: string;
  public date: string;
  public type: string;
  public status: string;
  public amountPaid: number;
  public employeeName: number;
}

export class CardInfo {
  public token: string = '';
  public number: number;
  public expMonth: number;
  public expYear: number;
  public cvn: string;
  public cardBrandTransactionId: string;
  public isCOF: boolean = false;
  public cardType: string;
  public cardBIN: string;
  public cardHolderName: string;

  //	public secretApiKey: string = '';
  //	public MID: string = '';
}

export class SettingsInvoice {
  public generalPaymentTerm: string;
  public generalPaymentTermCount: number = 0;
  public autoCreateInvoice: boolean = false;
  public sendEmailToOwnerOnAccept: boolean = false;
  public sendEmailToCreatorOnAccept: boolean = false;
  public enableMultipleInvoiceEmailSend: boolean = false;
  public defaultValidityDateDays: number = 0;
  public requireCustomerSignOrPasswordOnPayment: boolean = false;
  public requireCvvVerification: boolean = false;
  public userId: number = 0;
}

export class SettingsRecurringInvoice {
  public defaultScheduleNotificationId: number;
  public useSystemReminderEmailContent: boolean;
  public reminderEmailContent: string;
  public userId: number = 0;
  public notificationSchedule: NotificationScheduleOption;
}

export class NotificationScheduleOption {
  public id: number;
  public frequencyType: string;
  public frequencyValue: number;
}

export class CustomerSettingsInvoice {
  public id: number = 0;
  public paymentTermCount: number = 0;
  public paymentTerm: number = 0;
  public customerId: number = 0;
  public userId: number = 0;
}

export class CustomInvoiceField {
  public fieldId: number = 0;
  public fieldName: string = '';
  public isRequired: boolean = false;
  public fieldDataType: number = 167;
  public userId: number;
  public saving: any;
}

export class CustomInvoiceFieldValue {
  public fieldId: number = 0;
  public id: number = 0;
  public fieldName: string = '';
  public fieldDataType: number;
  public isRequired: boolean = false;
  public userId: number;
  public fieldValue: string = '';
  public saving: any;
  public invoiceNumber: string;
}

export class ManualInvoicePartialPaySetting {
  public id: number = 0;
  public invoiceNumber: string;
  public partialDueType: string;
  public partialDue: number;
  public userId: number;
}

export class UpdateInvoiceTipModel {
  InvoiceNumber: string;
  TipAmount: number;
  AmountDue: number;
  TipType: string;
}

export class PaymentWorkflowResponse {
  public Transaction: any;
  public Card: any;
  public CardLast4: string;
  public ServiceUrl: string;
  public UserId: number;
  public LocationId: number;
  public Invoice: any;
}

export class ManualInvoiceAutoSendSchedule {
  public Id: number;
  public ManualInvoiceId: number;
  public ScheduleDate: Date;
  public ScheduleStatus: string;
  public SentDate: Date;
  public UserId: number;

  public CreatedBy?: number;
  public CreatedDate?: Date;
  public UpdatedBy?: number;
  public UpdatedDate?: Date;
}

export class NonCustomerModel {
  id: number = 0;
  invoiceNumber: string;
  receiptEmail: string;
  lastName: string;
  firstName: string;
  createdBy: number = 0;
}

export class RecurringPayment {
  public Id?: number;
  public Status: string = 'Active';
  public ManualInvoiceId?: number;
  public NextRecurrenceDate?: string;
  public Configuration?: RecurringPaymentConfig;
}

export class RecurringPaymentConfig {
  IsOpenEnded: boolean = false;
  AutoSendPaymentRequestOnFail: boolean = false;
  RecurringInvoiceOnly: boolean = false;
  PaymentStartImmediately: boolean = false;
  StartDate: Date;
  EndDate: Date;
  CustomerCardNumberId: number;
  FrequencyRule: string;
  RecurringPaymentId: number;
  Id: number;
  ReminderFrequencyType: string;
  ReminderFrequencyValue: number;
}

export class RecurringInvoice {
  public Id?: number;
  public Status: string = 'Active';
  public ManualInvoiceId?: number;
  public NextRecurrenceDate?: string;
  public Configuration?: RecurringInvoiceConfig;
}

export class RecurringInvoiceConfig {
  IsOpenEnded: boolean = false;
  IsAutoCharge: boolean = false;
  RecurringFrequency: RecurringFrequency;
  PaymentStartImmediately: boolean = false;
  StartDate: Date;
  EndDate: Date;
  CustomerCardNumberId: number;
  FrequencyRule: string;
  RecurringInvoiceId: number;
  Id: number;
  ReminderFrequencyType: string;
  ReminderFrequencyValue: number;
}

export class RecurringFrequency {
  Id: number;
  RecurringInvoiceId: number;
  FrequencyType: FrequencyRepeatTypes = FrequencyRepeatTypes.Weekly;
  EndType: FrequencyEndType = FrequencyEndType.Count;
  Count: number = 2;
  Until: Date;
  Interval: number = 2;
  ByDay: string;
  ByDayArray: any[];
  ByMonth: number;
  ByMonthDay: number;
  BySetPos: number = 1;
  DayType: string = 'day';
}

export class RecurringInvoiceCancellation {
  Id: number;
  RecurringInvoiceId: number;
  ApprovalNotes: string;
  Status: string = 'For Approval';
  Reason: string;
  CancellationReasonId: number;
  RecurringInvoiceStatus: string;
  NumberOfInvoices: number = 0;
  UpdatedBy: number;
}

export class RecurringInvoiceSuspension {
  public Id: number;
  public RecurringInvoiceId: number;
  public SuspendedDate: Date;
  public SuspensionEndDate: Date;
  public Reason: string;
  public CreatedBy: number;
  public CreatedDate: Date;
  public CreatedDateTZBased: Date;
  public UpdatedBy: number;
  public UpdatedDate: Date;
  public UpdatedDateTZBased: Date;
  public CreatedByUserName: string;
  public UpdatedByUserName: string;
}

export enum FrequencyEndType {
  Never = 1,
  Until = 2,
  Count = 3,
}

export enum FrequencyRepeatTypes {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
}

export class RecurringInvoiceCancellationReason {
  public Id: number;
  public Description: string;
  public Createdby: number;
  public UpdatedBy: string;
}

export class RecurringInvoiceTip {
  RecurringInvoiceId: number;
  Tip: number;
  TipType: string;
  IsRepeatTipOnSucceedingInvoices: boolean = false;
  UpdatedBy: number;
}
